import Reveal from 'components/Reveal';
import Button from 'components/form/Button';
import React from 'react';

const services = [
  {
    icon: '/assets/icons/expertise.svg',
    title: 'Unparalleled Expertise',
    description:
      'With a team of seasoned professionals who possess a deep understanding of the ever-evolving crypto market, Skyview offers you unmatched expertise.',
  },
  {
    icon: '/assets/icons/chat_black.svg',
    title: 'Customer Service',
    description:
      'Our clients are at the heart of everything we do. We pride ourselves on delivering exceptional customer service.',
  },
  {
    icon: '/assets/icons/insight.svg',
    title: 'Education and Insights',
    description:
      'We are committed to empowering our clients with knowledge. Our educational resources and market insights provide you with the tools to make informed investment decisions.',
  },
  {
    icon: '/assets/icons/investment.svg',
    title: 'Good investment',
    description:
      'Your financial journey is unique, and we understand that. At Skyview , we offer personalized investment plans tailored to your specific needs.',
  },
];

const Services = () => {
  return (
    <Reveal>
      <section className="bg-light-gray mt-14 mb-3 px-3 pb-32" id="services">
        <h3 className="text-center text-[40px]">Our Services</h3>
        <br />
        <div className="container my-5 mx-auto">
          <div className="grid-col-1 grid gap-5 md:grid-cols-2">
            {services.map((service) => (
              <div
                className="h-00px] cursor-pointer rounded-md border bg-white p-5"
                key={service.title}
              >
                <div className="flex flex-col gap-y-5 p-5">
                  <img
                    src={service.icon}
                    alt="service_icon"
                    className="h-14 w-14"
                  />
                  <p className="text-xl font-bold capitalize">
                    {service.title}
                  </p>
                  <p className="">{service.description}</p>
                  <div className="flex justify-center">
                    <Button className="rounded-md border px-3 py-2">
                      view more
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Reveal>
  );
};

export default Services;
